import { type GenericDetailQueryKey, generateDetailQueryKey } from '@pba/react-query';
import { cesGroupsFeatureKey } from '../key';

type CesGroupDetailQueryType = GenericDetailQueryKey;

export const getCesGroupDetailQueryKey = generateDetailQueryKey({
  prefix: cesGroupsFeatureKey,
})<CesGroupDetailQueryType>;
